import { ResultsCollection } from '@sonar-software/xuder';
import { useMemo } from 'react';
import { useSonarSelector } from './useSonarSelector';
import { AsyncStateSelector, createCollectionSelector, createDataSelector } from '../lib/selectors';

export function useAsyncCollection<T>(
	stateSelector: AsyncStateSelector<ResultsCollection<T>>
): Array<T> {
	const resultSelector = useMemo(
		() => createCollectionSelector(createDataSelector(stateSelector)),
		[ stateSelector ]
	);

	const stateCollection = useSonarSelector(resultSelector);

	return useMemo(() => stateCollection ?? [], [ stateCollection ]) as Array<T>;
}
